import { DayType } from 'app/constants/dayType'

export const isLeaveDayType = (dayType: DayType) => {
  return isPaidLeaveDayType(dayType) || isNotPaidLeaveDayType(dayType)
}

export const isSickDayType = (dayType: DayType) => {
  if (
    dayType == DayType.C ||
    dayType == DayType.Cn ||
    dayType == DayType.Cb ||
    dayType == DayType.Oo ||
    dayType == DayType.Od ||
    dayType == DayType.Or ||
    dayType == DayType.Rb ||
    dayType == DayType.Rc ||
    dayType == DayType.Rw ||
    dayType == DayType.Z ||
    dayType == DayType.Zb ||
    dayType == DayType.Zn ||
    dayType == DayType.Zs ||
    dayType == DayType.Zw ||
    dayType == DayType.Uoj ||
    dayType == DayType.M ||
    dayType == DayType.WoC ||
    dayType == DayType.WoCn ||
    dayType == DayType.WoCb ||
    dayType == DayType.WoOo ||
    dayType == DayType.WoOd ||
    dayType == DayType.WoOr ||
    dayType == DayType.WoRb ||
    dayType == DayType.WoRc ||
    dayType == DayType.WoRw ||
    dayType == DayType.WoZ ||
    dayType == DayType.WoZb ||
    dayType == DayType.WoZn ||
    dayType == DayType.WoZs ||
    dayType == DayType.WoZw ||
    dayType == DayType.WoUoj ||
    dayType == DayType.WoM
  ) {
    return true
  }

  return false
}

export const isPaidLeaveDayType = (dayType: DayType): boolean => {
  if (
    dayType == DayType.U ||
    dayType == DayType.U2 ||
    dayType == DayType.Ui ||
    dayType == DayType.Um ||
    dayType == DayType.Un ||
    dayType == DayType.Uo ||
    dayType == DayType.Ur ||
    dayType == DayType.Us ||
    dayType == DayType.Ux ||
    dayType == DayType.Uz ||
    dayType == DayType.D1 ||
    dayType == DayType.D2
  ) {
    return true
  }

  return false
}

export const isNotWorkingDayType = (dayType: DayType): boolean => {
  if (
    dayType == DayType.W ||
    dayType == DayType.Wn ||
    dayType == DayType.Ws ||
    dayType == DayType.Wx ||
    dayType == DayType.Wo ||
    dayType == DayType.Pw
  ) {
    return true
  }

  return false
}

export const isNotPaidLeaveDayType = (dayType: DayType): boolean => {
  if (
    dayType == DayType.Bw ||
    dayType == DayType.Bp ||
    dayType == DayType.Nn ||
    dayType == DayType.Nu ||
    dayType == DayType.Uf ||
    dayType == DayType.Cn ||
    dayType == DayType.Zn ||
    dayType == DayType.Oo
  ) {
    return true
  }

  return false
}

export const isTruancyDayType = (dayType: DayType): boolean => {
  if (dayType == DayType.Nn || dayType == DayType.NoContract) {
    return true
  }

  return false
}
